<template>
  <div class="container-fluid">
    <div class="create-baseline-button">
      <b-button variant="primary" v-b-modal.create-baseline-modal>
        Create baseline
      </b-button>
    </div>
    <create-baseline-modal></create-baseline-modal>
    <div class="row">
      <section class="col-md-3">
        <baseline-list :baselines="baselines"></baseline-list>
      </section>
      <div class="col-md-9">
        <baseline-detail v-if="currentBaseline" :baseline-prop="currentBaseline"></baseline-detail>
      </div>
    </div>
  </div>
</template>

<script>
  import AppNav from './AppNav.vue'
  import BaselineDetail from './BaselineDetail.vue'
  import BaselineList from './BaselineList.vue'
  import CreateBaselineModal from '@/components/modals/CreateBaselineModal'
  export default {
    components: { AppNav, BaselineDetail, BaselineList, CreateBaselineModal },
    data () {
      return {
        baselines: []
      }
    },
    computed: {
      currentBaseline () {
        return this.$store.state.currentBaseline
      },
      currentProject () {
        return this.$store.state.currentProject
      },
      needToRefreshBaselineList () {
        return this.$store.state.needToRefreshBaselineList
      }
    },
    watch: {
      currentProject (newValue, oldValue) {
        if (this.currentProject) {
          this.getBaselines()
          if (oldValue && oldValue.id.toString() !== newValue.id.toString()) {
            this.$store.commit('setCurrentBaseline', null)
          }
        }
      },
      needToRefreshBaselineList (currentValue) {
        if (currentValue === true) {
          // Refresh then set the value to be false
          this.getBaselines()
          this.$store.commit('setNeedToRefreshBaselineList', false)
        }
      }
    },
    mounted () {
      this.getBaselines()
    },
    methods: {
      getBaselines () {
        this.$http.get(
          '/api/baseline?atlassian_project_id=' + this.currentProject.id
        ).then(response => {
          this.baselines = response.data.baselines
        }, response => {
          console.log('error')
        })
      }
    }
  }
</script>

<style>
  .create-baseline-button {
    margin: 15px;
  }
</style>



// WEBPACK FOOTER //
// BaselineExplorer.vue?0203b9a0